<template>
<div>
    <div class="setting-area">
        <p class="simple-ttl">カメラ詳細設定</p>
        <div class="simple-table -col02">
            <table>
                <tbody>
                    <tr>
                        <td>
                            <p>端末ID</p>
                        </td>
                        <td class="no-border-right">
                            <p class="details-term-id">{{cameraInfo.term_id}}</p>
                        </td>
                        <td class="no-border-left"></td>
                    </tr>
                    <tr>
                        <td>
                            <p class="-required">カメラ名</p>
                        </td>
                        <td class="no-border-right">
                            <p class="input-wrap">
                                <label for="cameraName"></label>
                                <input v-model.trim="form.cameraName" type="text" id="cameraName" required>
                            </p>
                        </td>
                        <td class="no-border-left">
                            <button class="resetButton" @click="resetWord('cameraName')">クリア</button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p class="-required">カメラURL</p>
                        </td>
                        <td class="no-border-right">
                            <div>
                                <p class="cameraUrl urlProtocol">
                                  <label for="cameraUrlProtocol"></label>
                                  <select v-model.trim="form.cameraUrlProtocol" class="settingSelect" id="selectProtocol" required>
                                      <option value=""></option>
                                      <option value="http://">http://</option>
                                      <option value="https://">https://</option>
                                  </select>
                                </p>
                                <p class="input-wrap cameraUrl urlDomain">
                                    <label for="cameraUrl"></label>
                                    <input v-model.trim="form.cameraUrl" type="text" id="cameraUrl" required>
                                </p>
                            </div>
                        </td>
                        <td class="no-border-left">
                            <button class="resetButton" @click="resetWord('cameraUrl')">クリア</button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                          <p class="-required">RTSPポート番号</p>
                        </td>
                        <td class="no-border-right">
                            <p class="input-wrap">
                                <label for="rtspPort"></label>
                                <input v-model.trim="form.rtspPort" type="text" id="rtspPort" required>
                            </p>
                        </td>
                        <td class="no-border-left">
                            <button class="resetButton" @click="resetWord('rtspPort')">クリア</button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="simple-table -col02">
            <table>
                <tbody>
                    <tr>
                        <td>
                            <p class="-required">表示順</p>
                        </td>
                        <td class="no-border-right">
                            <p class="input-wrap -column">
                                <label for="sortNum"></label>
                                <input v-model.trim="form.sortNum" class="-mini" id="sortNum" type="text" required><span>ホーム画面やライブ画面などのカメラ順を設定できます。0の場合、カメラ設定の表示順は空で出力されます。</span>
                            </p>
                        </td>
                        <td class="no-border-left">
                            <button class="resetButton" @click="resetWord('sortNum')">クリア</button>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <p class="-required">機種名</p>
                        </td>
                        <td class="no-border-right">
                            <div class="select-wrap">
                                <div class="selectbox -middle">
                                    <label for="selectedModelName"></label>
                                    <select name="selectedModelName" v-model="form.selectedModelName" class="-middle settingSelect" id="selectedModelName" required>
                                        <option v-for="(list, key) in deviceInfo" :key="key" :value="list.device_id" :id="'selectedModelName_' + list.model_name">{{list.model_name}}</option>
                                    </select>
                                </div>
                            </div>
                        </td>
                        <td class="no-border-left"></td>
                    </tr>
                    <tr>
                        <td>
                            <p>タイムゾーン</p>
                        </td>
                        <td class="no-border-right">
                            <p class="details-timezone">{{timezoneInfo[0].japanese_name}}</p>
                        </td>
                        <td class="no-border-left"></td>
                      </tr>
                      <tr>
                          <td>
                              <p class="-required">認証設定</p>
                          </td>
                          <td class="no-border-right">
                              <div class="select-wrap -column">
                                  <div class="selectbox -large">
                                    <label for="selectedAuthName"></label>
                                    <select v-model="form.selectedAuthName" class="-middle settingSelect" id="selectedAuthName" name="selectedAuthName" required>
                                      <option v-for="(list, key) in authName" :key="key" :id="'selectedAuthName_' + list" :value="list">{{list}}</option>
                                    </select>
                                  </div>
                                  <div class="simple-table -col02 -mini">
                                      <table>
                                          <tbody>
                                              <tr>
                                                  <td>
                                                      <p>ID</p>
                                                  </td>
                                                  <td>
                                                      <p class="input-wrap">
                                                          <label for="selectedAuthId"></label>
                                                          <input v-model.trim="form.selectedAuthId" type="text" id="selectedAuthId" required>
                                                      </p>
                                                  </td>
                                              </tr>
                                              <tr>
                                                  <td>
                                                      <p>パスワード</p>
                                                  </td>
                                                  <td>
                                                      <p class="input-wrap">
                                                          <label for="selectedAuthPass"></label>
                                                          <input v-model.trim="form.selectedAuthPass" type="password" id="selectedAuthPass" required>
                                                      </p>
                                                  </td>
                                              </tr>
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </td>
                          <td class="no-border-left">
                              <button class="resetButton" @click="resetWord('selectedAuth')">クリア</button>
                          </td>
                      </tr>
                </tbody>
            </table>
        </div>
    </div>
    <button class="change-btn" @click="confirmModifySettingInfo()" type="submit">変更を保存</button>
</div>
</template>
<script>
const apiUrl = process.env.VUE_APP_API_apiUrl;

import commonValidationCheck from '../../js/modules/componentCommonValidationCheck';

export default {
    name: 'SettingCamDetailsComponent',
    data(){
        return {
          // 認証プロトコル一覧
          authName: [
            "basic", "digest"
          ],
          // 設定情報をformとして渡す情報を保持するdata属性
          // this.cameraInfoは初期値を表示するための設定
          form: {
            cameraName          : this.cameraInfo.description,
            cameraUrlProtocol   : '',
            cameraUrl           : '',
            // cameraUrl           : this.cameraInfo.camera_host,
            sortNum             : this.cameraInfo.sort,
            selectedModelName   : this.cameraInfo.device_id,
            selectedTimezoneName: this.cameraInfo.timezone_id,
            selectedAuthName    : this.cameraInfo.auth_method,
            selectedAuthId      : this.cameraInfo.camera_auth_userid,
            selectedAuthPass    : this.cameraInfo.camera_auth_password,
            rtspPort            : this.cameraInfo.camera_rtsp_port_no,
          },
          // パンくずリストで移動する際に使用するrouter URL
          routerLink: '/settings?site_no=' + this.$store.getters['auth/getSiteNo'],
          alertInfo_widgetError: ""
        }
    },
    props:{
        siteInfo:{
            type: Object
        },
        cameraInfo:{
            type: Object
        },
        deviceInfo:{
            type: Array
        },
        timezoneInfo:{
            type: Array
        }
    },
    methods: {
      //**********************************************************/
      // クリアボタンを押下したときの動作
      /**********************************************************/
      resetWord: function (target) {
            if (target === 'cameraName') {
                this.form.cameraName = '';
            }
            if (target === 'cameraUrl') {
                this.form.cameraUrlProtocol = '';
                this.form.cameraUrl = '';
            }
            if (target === 'rtspPort') {
                this.form.rtspPort = '';
            }
            if (target === 'sortNum') {
                this.form.sortNum = '';
            }
            if (target === 'selectedAuth') {
                this.form.selectedAuthId = '';
                this.form.selectedAuthPass = '';
            }
      },
      //**********************************************************/
      // API実施
      /**********************************************************/
      callApiForInfo: async function(param, method, queries){
          // 関数return値を配置する変数
          var isApiData = "";
          await this.$store.dispatch('requestApi/' + method + 'ApiInfoAction', {
              url: apiUrl + param,
              params: queries
          })
          // 以下「eslint-disable-line」を使用することにより、不要なバリデーションを除外する
          .then(response => { // eslint-disable-line
                this.infoCallingApi = this.$store.getters['requestApi/' + method + 'ApiInfo'];
                isApiData = this.infoCallingApi;

                // ローディングフィニッシュ
                this.$emit('settingChangeLoadFinish');

                this.$emit('showResultMessage', {
                    transitionLogoutPageFlg: false,
                    transitionTopPageFlg: false,
                    execFlg: true,
                    message:"データ更新成功",
                    sub_message:"データの変更が完了しました。",
                    errorFlag: false
                });
          }, error => {// eslint-disable-line
                // ローディングフィニッシュ
                this.$emit('settingChangeLoadFinish');

                if (error == "Error: Request failed with status code 401") {
                    sessionStorage.clear();
                    window.localStorage.removeItem('TodoApp');
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: true,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"エラー",
                        sub_message:"ログインし直してください。",
                        errorFlag: true
                    });
                } else if (error == "Error: Request failed with status code 400") {
                    // 未入力の項目があった場合
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"入力エラー",
                        sub_message:"全ての項目を入力してください。",
                        errorFlag: true
                    });
                } else{
                    this.$emit('showResultMessage', {
                        transitionLogoutPageFlg: false,
                        transitionTopPageFlg: false,
                        execFlg: false,
                        message:"データ更新失敗",
                        sub_message:"データの変更に失敗しました。",
                        errorFlag: true
                    });
                }
          })
          return isApiData
      },
      //**********************************************************/
      // 変更確認ポップアップの表示のための処理
      // 各入力項目→空欄×、半角スペース×、全角スペース×
      // RTSPポート番号・表示順→0を含めた1以上の整数
      /**********************************************************/
      confirmModifySettingInfo: function(){
        // カメラ名
        if(this.form.cameraName === ""){
            this.$emit('showResultMessage', {
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: false,
                execFlg: false,
                message:"入力エラー",
                sub_message:"カメラ名を入力してください",
                errorFlag: true
            });
        // カメラURL
        } else if (this.form.cameraUrlProtocol === "" || this.form.cameraUrl === "") {
            this.$emit('showResultMessage', {
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: false,
                execFlg: false,
                message:"入力エラー",
                sub_message:"カメラURLを入力してください",
                errorFlag: true
            });
        // RTSPポート番号→1以上の整数〇、0〇
        } else if (!(commonValidationCheck.isNumber(this.form.rtspPort) || this.form.rtspPort === "0")) {
            this.$emit('showResultMessage', {
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: false,
                execFlg: false,
                message:"入力エラー",
                sub_message:"RTSPポート番号には0以上の整数値を入力してください。",
                errorFlag: true
            });
        // 表示順→1以上の整数〇、0〇
        } else if (!((commonValidationCheck.isNumber(this.form.sortNum)) || this.form.sortNum === "0")) {
            this.$emit('showResultMessage', {
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: false,
                execFlg: false,
                message:"入力エラー",
                sub_message:"表示順には0以上の整数値を入力してください。",
                errorFlag: true
            });
        // 機種名
        } else if (this.form.selectedModelName === "") {
            this.$emit('showResultMessage', {
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: false,
                execFlg: false,
                message:"入力エラー",
                sub_message:"機種名を選択してください",
                errorFlag: true
            });
        // 認証設定
        } else if (this.form.selectedAuthName === "") {
            this.$emit('showResultMessage', {
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: false,
                execFlg: false,
                message:"入力エラー",
                sub_message:"認証設定を選択してください",
                errorFlag: true
            });
        // ID
        } else if (this.form.selectedAuthId === "") {
            this.$emit('showResultMessage', {
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: false,
                execFlg: false,
                message:"入力エラー",
                sub_message:"IDを入力してください",
                errorFlag: true
            });
        // パスワード
        } else if (this.form.selectedAuthPass === "") {
            this.$emit('showResultMessage', {
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: false,
                execFlg: false,
                message:"入力エラー",
                sub_message:"パスワードを入力してください",
                errorFlag: true
            });
        } else {
            this.$emit('displaySettingConfirm')
        }
      },
      //**********************************************************/
      // 変更確認ポップアップの表示後、
      // 適用された後のAPI呼び出し処理実行とポップアップ非表示処理
      /**********************************************************/
      modifySettingStatusChange: function () {
          this.updateCameraInfo(this.siteInfo.site_no, this.cameraInfo.term_id);
      },
      //**********************************************************/
      // form値validation実施処理
      /**********************************************************/
      validationFormValue: function(){
        const form = this.form;
        return {
          cameraName           :(form.cameraName),
          cameraUrlProtocol    :(form.cameraUrlProtocol),
          cameraUrl            :(form.cameraUrl),
          sortNum              :(form.sortNum),
          selectedModelName    :(form.selectedModelName),
          selectedTimezoneName :(form.selectedTimezoneName),
          selectedAuthName     :(form.selectedAuthName),
          selectedAuthId       :(form.selectedAuthId),
          selectedAuthPass     :(form.selectedAuthPass),
          rtspPort             :(form.rtspPort),
        }
      },
      //**********************************************************/
      // form値validation実施後のform送信ボタンチェック処理
      /**********************************************************/
      isValid: function(){
        const validationFormValue = this.validationFormValue
        return Object.keys(validationFormValue).every(
          key => {
            if(!validationFormValue[key]){
              this.alertInfo_widgetError = "データ入力に誤りがあります。" + validationFormValue[key] + "の値をご確認ください。";
            }
            return validationFormValue[key]
          }
        )
      },
      //**********************************************************/
      // optionタグデフォルト選択設定処理
      // 例）認証関数条件分岐処理
      /**********************************************************/
      // 引数
      // method: this.cameraInfo
      /**********************************************************/
      optionTagSelected: function(Element){
        this.$nextTick(async function () {
          const obj = document.getElementById(Element);
          if (obj !== null) {
            obj.selected = true;
          }
        })
      },
      //**********************************************************/
      // routerをリロードする処理
      /**********************************************************/
      loadBrowser: function(){
        window.location.href = "./camera?site_no=" + this.$store.getters['auth/getSiteNo'];
      },
      //**********************************************************/
      // 現場・カメラ情報変更のためのAPI実施処理
      /**********************************************************/
      // 引数
      // site_no: 現場情報
      // term_id: 端末情報
      /**********************************************************/
      updateCameraInfo: async function(site_no, term_id) {// eslint-disable-line
        // シリアル番号のバリデーションチェックが成功した場合の処理
        if(!await this.isValid()){
          alert(this.alertInfo_widgetError)
        }else{
          if ((this.form.cameraUrlProtocol !== '' && this.form.cameraUrl === '') || (this.form.cameraUrlProtocol === '' && this.form.cameraUrl !== '') || (this.form.cameraUrl.indexOf('://') != -1)) {
            this.$emit('showResultMessage', {
                transitionLogoutPageFlg: false,
                transitionTopPageFlg: false,
                execFlg: false,
                message:"入力エラー",
                sub_message:"カメラURLが不正です。",
                errorFlag: true
            });
          } else {
            // RTSPポート番号が未入力の場合にデフォルト値554をセットする
            var rtspPortNo = ''
            if (this.form.rtspPort === '') {
              rtspPortNo = '554';
            } else {
              rtspPortNo = this.form.rtspPort;
            }
            // 設定情報をputする際に必要となる情報をオブジェクトとして管理
            var cameraHostUrl = this.form.cameraUrlProtocol + this.form.cameraUrl
            const queryParam = {// eslint-disable-line
              description  : this.form.cameraName,
              protocol            : 'rtsp',
              camera_host         : cameraHostUrl,
              timezone_id         : this.form.selectedTimezoneName,
              sort_num            : this.form.sortNum,
              device_id           : this.form.selectedModelName,
              auth_method         : this.form.selectedAuthName,
              auth_userid         : this.form.selectedAuthId,
              auth_password       : this.form.selectedAuthPass,
              camera_rtsp_port_no : rtspPortNo,
            };
            // live_access_token処理を格納しているオブジェクトに他のクエリパラメータを配置
            var queries = { live_access_token: this.$store.getters['auth/getLiveAccessToken'] };
            const queryParams = Object.assign(queries, queryParam);// eslint-disable-line

            // 設定情報変更API処理の実行
            await this.callApiForInfo('sites/' + site_no + '/terms/' + term_id, "put", queryParams)
          }
        }
      }
    },
    mounted: async function() {
      scrollTo(0, 0);
      // ビュー全体がレンダリングされるまで待つ
      this.$nextTick(async function () {
        // 機種名のoptionタグデフォルト選択
        await this.optionTagSelected('selectedModelName_' + this.cameraInfo.device_name);
        // タイムゾーンのoptionタグデフォルト選択
        await this.optionTagSelected('selectedTimezoneName_' + this.cameraInfo.term_id + '_' + this.form.selectedTimezoneName);
        // 認証設定のoptionタグデフォルト選択
        await this.optionTagSelected('selectedAuthName_' + this.cameraInfo.auth_method);

        // カメラURLをprotocolとfqdnに分けてデフォルト値として設定
        var protocol = '';
        var fqdn = '';
        if (this.cameraInfo.camera_host !== '') {
          if (this.cameraInfo.camera_host.indexOf('://') == -1) {
            fqdn = this.cameraInfo.camera_host;
          } else {
            var url = this.cameraInfo.camera_host.split('://');
            protocol = url[0] + '://';
            fqdn = url[1];
          }
        }
        this.form.cameraUrlProtocol = protocol;
        this.form.cameraUrl = fqdn;

        history.pushState(null, null, null);
        // ブラウザバックを検視した場合にカメラ一覧に戻るようにする
        window.addEventListener('popstate', () => {
          this.$emit('cameraListsDisplay', {execFlg: true});
        });
      })
    },
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/main/SettingCamDetailsComponent.css";
</style>